module.exports = __webpack_public_path__ + "img/cabr4.26e644c2.png";